import { createEventTracker } from '../util';
import { HeatmapAnalytics, HeatmapCardViewedAnalytics, HeatmapViewedAnalytics } from './types';

export const trackHeatmapViewed = createEventTracker<HeatmapViewedAnalytics>('Heatmap Viewed');
export const trackHeatmapSaved = createEventTracker<HeatmapAnalytics>('Heatmap Saved');
export const trackHeatmapCardViewed =
  createEventTracker<HeatmapCardViewedAnalytics>('Heatmap Card Viewed');
